<template>
  <ul class="pagination" v-if="data.total > 0">
    <li><a @click="handleClick(1)">«</a></li>
    <li @click="handleClick(val)" v-for="val in data.last_page">
      <a  href="#" :class="(val === data.current_page) ? 'active' : ''">{{val}}</a>
    </li>
    <li><a @click="handleClick(data.last_page)">»</a></li>
  </ul>
</template>

<script>
export default {
  props: {
    data: {
      required: true
    },
  },
  methods: {
    handleClick: function(val) {
      this.$emit('changePage', val)
    }
  }
}
</script>

<style scoped>
ul.pagination {
  display: inline-block;
  padding: 0;
  margin: 0;
}

ul.pagination li {display: inline;}

ul.pagination li a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  border-radius: 5px;
  cursor: pointer;
}

ul.pagination li a.active {
  background-color: #4CAF50;
  color: white;
  border-radius: 5px;
}

ul.pagination li a:hover:not(.active) {background-color: #ddd;}
</style>
